import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { Router } from '@angular/router';

// import { RouterFacade } from '@heitown/frontend-routing-utils';

@Component({
  standalone: false,
  selector: 'ideapa-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  isLoading: boolean | undefined;

  constructor(private router: Router, private cd: ChangeDetectorRef) {}
}
